import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { addDisplayName } from "../Infra/display-name";
import { PatientRecordsHero } from "./PatientRecordsHero";
import { PatientRecordsSection, PatientRecordsViewModel } from "./PatientRecordsViewModel";
import { PatientSourcesView } from "./PatientSourcesView";
import { PatientTimelineView } from "./PatientTimelineView";
import { TimelinePageRoot } from "./PatientTimelineView.styles";
import { PillTabActive, PillTabInactive, PillTabsContainer, PillTabsTrack } from "./PillTabs.styles";
import { useViewModel } from "./useViewModel";
export const PatientRecordsView = observer((props) => {
    const { t } = useTranslation(["patients"]);
    const model = useViewModel(PatientRecordsViewModel, props.container);
    if (!model.isHealthWalletEnabled) {
        return _jsx(PatientTimelineView, { container: props.container });
    }
    if (!model.isSourcesTabEnabled) {
        return (_jsxs(TimelinePageRoot, { children: [_jsx(PatientRecordsHero, { moreMenuController: model.moreMenuController }), _jsx(PatientTimelineView, { container: props.container, moreMenuController: model.moreMenuController })] }));
    }
    return (_jsxs(TimelinePageRoot, { children: [_jsx(PatientRecordsHero, { moreMenuController: model.moreMenuController }), pillTabs(), model.currentSection === PatientRecordsSection.TIMELINE ? (_jsx(PatientTimelineView, { container: props.container, moreMenuController: model.moreMenuController })) : (_jsx(PatientSourcesView, { container: props.container, moreMenuController: model.moreMenuController }))] }));
    function pillTabs() {
        const isTimeline = model.currentSection === PatientRecordsSection.TIMELINE;
        const TimelineTab = isTimeline ? PillTabActive : PillTabInactive;
        const SourcesTab = isTimeline ? PillTabInactive : PillTabActive;
        return (_jsx(PillTabsContainer, { children: _jsxs(PillTabsTrack, { children: [_jsx(TimelineTab, { type: "button", onClick: () => model.setSection(PatientRecordsSection.TIMELINE), children: t("Timeline") }), _jsx(SourcesTab, { type: "button", onClick: () => model.setSection(PatientRecordsSection.SOURCES), children: t("Sources") })] }) }));
    }
});
addDisplayName(PatientRecordsView, "PatientRecordsView");
